<template>
  <span class="chat-av" :class="{ 'chat-av--group': group }" :style="style" :title="name">
    <i v-if="group" class="fe fe-users"></i>
    <template v-else>{{ letters }}</template>
  </span>
</template>

<script>
import { initials } from "../format";

const COLORS = ["#2563eb", "#0891b2", "#059669", "#7c3aed", "#db2777", "#ea580c", "#4f46e5", "#0d9488"];

// Round avatar with initials (colour from the user id), or a group icon.
export default {
  name: "ChatAvatar",
  props: {
    name: { type: String, default: "" },
    id: { type: [Number, String], default: 0 },
    group: { type: Boolean, default: false },
    size: { type: Number, default: 40 },
  },
  computed: {
    letters() {
      return initials(this.name);
    },
    style() {
      const bg = this.group ? "#64748b" : COLORS[Math.abs(Number(this.id) || 0) % COLORS.length];
      return { width: `${this.size}px`, height: `${this.size}px`, fontSize: `${Math.round(this.size * 0.36)}px`, background: bg };
    },
  },
};
</script>

<style scoped>
.chat-av {
  flex-shrink: 0;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.02em;
}
</style>
